export default "__VITE_ASSET__BrPxCcj4__"